module.exports = __webpack_public_path__ + "static/21-36516fc7623aa5ee5665c2cfb2cf62d5.png";